<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component v-if="item.name === '1'" :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)"></component>
      <component v-else :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor="26"></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import filters from '../method/filter.js'
import {mapState} from 'vuex'
import Hyfblb from '../assembly/xsyz/Hyfblb.vue'
import XmhzLB from '../assembly/XmhzLB.vue'
import KcpLB from '../assembly/KcpLB.vue'
import ZbysLB from '../assembly/ZbysLB.vue'
import KysbLB from '../assembly/KysbLB.vue'
import KyyjLB from '../assembly/KyyjLB.vue'
export default {
  mixins: [filters],
  components: {
    Hyfblb,
    XmhzLB,
    KcpLB,
    ZbysLB,
    KysbLB,
    KyyjLB
  },
  data()
  {
    return {
      selectList: [{value: 'type', name: '所属分类', parentdispc: '', dispc: '', tableData: []}],
      //tab页默认选中
      activeName: 'second',
      editableTabsValue: '1',
      editableTabs: [
        {
          title: '会议发布审核列表',
          name: '1',
          closable: false,
          content: Hyfblb
        },
        {
          title: `项目合作审核列表`,
          name: '2',
          closable: false,
          content: XmhzLB
        },
        {
          title: '矿产品审核列表',
          name: '3',
          closable: false,
          content: KcpLB
        },
        {
          title: '珠宝玉石审核列表',
          name: '4',
          closable: false,
          content: ZbysLB
        },
        {
          title: '矿业设备审核列表',
          name: '5',
          closable: false,
          content: KysbLB
        },
        {
          title: '矿用药剂审核列表',
          name: '6',
          closable: false,
          content: KyyjLB
        }
      ]
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName,
      nodeid: state => state.NavID
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.activeName = nval.activeName
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //添加下拉值
    onSubmit(obj)
    {
      let params =
      {
        cmd: 'add',
        _major: 99,
        _minor: 20,
        retAtt: 1,
        moduleid: this.nodeid,
        dispc: obj.dispc,
        colname: obj.value,
        major: 11,
        minor: 26,
        glid: obj.parentdispc || 0
      }
      window.post.getPost(params).then(res =>
      {
        if (res instanceof Object)
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
      })
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ToExamine.vue